import client from "./client";
import type {
  LoginRequest,
  RegisterRequest,
  TokenResponse,
  User,
} from "@/types";

export async function login(data: LoginRequest): Promise<TokenResponse> {
  const res = await client.post<TokenResponse>("/auth/login", data);
  return res.data;
}

export async function register(data: RegisterRequest): Promise<User> {
  const res = await client.post<User>("/auth/register", data);
  return res.data;
}

export async function getMe(): Promise<User> {
  const res = await client.get<User>("/auth/me");
  return res.data;
}

export async function updateMe(data: {
  full_name?: string;
  phone?: string;
}): Promise<User> {
  const res = await client.patch<User>("/auth/me", data);
  return res.data;
}

export interface SendCodeResponse {
  message: string;
  method: string;
  code?: string;
  need_bot_start?: boolean;
  bot_username?: string;
}

export async function sendVerificationCode(
  email: string,
  method: "email" | "telegram",
): Promise<SendCodeResponse> {
  const res = await client.post("/auth/send-code", { email, method });
  return res.data;
}

export async function verifyCode(
  email: string,
  code: string,
): Promise<{ verified: boolean; message: string }> {
  const res = await client.post("/auth/verify-code", { email, code });
  return res.data;
}

// ── Password reset ──

export async function forgotPassword(
  email: string,
  method: "email" | "telegram" = "email",
): Promise<{ message: string; method: string; code?: string }> {
  const res = await client.post("/auth/forgot-password", { email, method });
  return res.data;
}

export async function resetPassword(
  email: string,
  code: string,
  new_password: string,
): Promise<{ message: string }> {
  const res = await client.post("/auth/reset-password", {
    email,
    code,
    new_password,
  });
  return res.data;
}

// ── Profile change with verification ──

export async function requestEmailChange(
  newEmail: string,
): Promise<{ message: string; code?: string }> {
  const res = await client.post("/auth/me/request-email-change", {
    new_email: newEmail,
  });
  return res.data;
}

export async function confirmEmailChange(
  newEmail: string,
  code: string,
): Promise<User> {
  const res = await client.post<User>("/auth/me/confirm-email-change", {
    new_email: newEmail,
    code,
  });
  return res.data;
}

export async function requestTgChange(
  newTgUsername: string,
): Promise<{ message: string; code?: string }> {
  const res = await client.post("/auth/me/request-tg-change", {
    new_tg_username: newTgUsername,
  });
  return res.data;
}

export async function confirmTgChange(
  newTgUsername: string,
  code: string,
): Promise<User> {
  const res = await client.post<User>("/auth/me/confirm-tg-change", {
    new_tg_username: newTgUsername,
    code,
  });
  return res.data;
}
